import React, { useEffect, useState } from "react";
import PageLayout from "../../../components/PageLayout";
import AddApp from "./AddApp";
import HelpDocuments from "./HelpDocuments";
import SupportButton from "../../../components/Common/SupportButton";
import APIDocuments from "./APIDocuments";
import PlanSpecification from "./PlanSpecification";
import { useDispatch, useSelector } from "react-redux";
import { CustomToast } from "../../../components/Lystface/Common/CustomToast";
import PaymentLayout from "./PaymentLayout";
import { getInvoices } from "../../../store/actions";
import moment from "moment";
import { getTransactionLimit } from "../../../store/menu/home/actions";


const Home = () => {
  const pageName = "Home";
  const planSpecificaionState = useSelector(state => state.Home?.planSpecificationDetails?.plan)
  const { frstApiCl, plan } = planSpecificaionState
  const { frstApiCl: frstApiClfromConstansAPi, startCh } = useSelector(state => state.Login.constDetails)
  const GetStartedState = useSelector(state => state.Home?.getStarted)
  const { check, responseMessage } = GetStartedState
  const [closed, setClosed] = useState(false)
  const BillSetState = useSelector(state => state.BillSet)
  const { invList } = BillSetState
  const dispatch = useDispatch();
  const invoicePending = invList?.invoice?.length > 0 && invList?.invoice[0]?.status !== "paid"
  const date = moment(invList?.invoice[0]?.created, "DD MMM YYYY").format("MMM YYYY")
  const TransactionLimitState = useSelector(state => state.Home?.transactionLimit)
  const { limitAboutToExceed } = TransactionLimitState

  useEffect(() => {
    dispatch(getInvoices({ status: "" }))
    dispatch(getTransactionLimit())
  }, [])

  useEffect(() => {
    if (responseMessage !== null) {
      CustomToast({
        message: responseMessage,
        status: 'failure',
        closeToast: () => {
          console.log('Toast closed');
        }
      })
    }

  }, [responseMessage])

  return (
    <React.Fragment>
      <PageLayout pageName={pageName} >
        {
          (invoicePending || limitAboutToExceed) &&
          <PaymentLayout date={date} plan={plan?.category} limitExceed={limitAboutToExceed} />

        }
        {
          (!startCh && !check && !closed) &&
          <HelpDocuments setClosed={setClosed} />

        }
        {
          (frstApiCl || frstApiClfromConstansAPi) &&
          <PlanSpecification />

        }
        <AddApp from="home" />
        <APIDocuments />
        <SupportButton />
      </PageLayout>
    </React.Fragment>
  );
};

export default Home;